import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Spinner,
    TextControl,
} from '@wordpress/components';
import { fetchData, saveData } from './api';

const TranslationTab = ({ openPopup , setActiveTab }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwpdl_wp_ajax.getsettings, gmwpdl_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    const saveSettings = () => {
        setIsSaving(true);
        saveData(gmwpdl_wp_ajax.savedata, gmwpdl_wp_ajax.nonce, data)
            .then((responseData) => {
                setIsSaving(false);
                console.log
                if (responseData.success) {
                    openPopup('Settings saved!');
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };

    // Check if gmwpdl_translation_arr exists and is an object
    const translationArr = gmwpdl_wp_ajax.gmwpdl_translation || {};

    return (
        <PanelBody>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    <table className="GMadminTable">
                        {Object.entries(translationArr).map(([key, value]) => (
                            <tr key={key}>
                                <th>
                                    <label>{value.label}</label>
                                </th>
                                <td>
                                    <TextControl
                                        onChange={(value) => updateField(key, value)}
                                        value={data[key]}
                                    />
                                </td>
                            </tr>
                        ))}
                    </table>
                    <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                        {isSaving ? <Spinner /> : 'Save Settings'}
                    </Button>
                </>
            )}
        </PanelBody>
    );
};

export default TranslationTab;
